import {Deserializable} from "../deserializable.model";

export class ErrorModel {
    UserId!:string;
    ComponentName!:string;
    MethodName!:string;
    ErrorMessage!:string
}
